<template>

    <div>

        <div v-if="multiple">
            <v-chip
                v-for="chip in patientChips"
                :key="`sspchip_${chip.id}`"
                :color="chipColor"
                :text-color="chipTextColor"
                close
                @click:close="unSelectChip(chip)"
            >
            {{chip.chip}}
            </v-chip>

        </div>

        <v-autocomplete
                light dense flat outlined solo
                v-model="patientFound"
                :items="items"
                :loading="isLoadingSearch"
                :search-input.sync="searchPatients"
                :item-text="getNamePatient"
                label="Search Patients"
                background-color="white"
                return-object
                disabled="disabled"
                clearable/>
    </div>

</template>

<script>
import {mapActions, mapGetters} from "vuex";
    export default {
        name: 'scheduleSearchPatient',
        components: {
        },
        props: {
            value: {
                default: ''
            },
            nameFormat: {
                type: String,
                default: 'first'
            },
            group_id: {
                type: String,
                default: ''
            },  
            multiple: {
                default: false,
                type: Boolean
            },
            chipColor: {
                type: String,
                default: ''
            },
            chipTextColor: {
                type: String,
                default: ''
            },
            disabled: {
                type: Boolean,
                default: false
            },               
        },
        data: () => ({
            isLoadingSearch: false,
            items: [],
            searchPatients: null,
            patientFound: null,
            patientChips: null,
        }),
        mounted() {
            this.loadLocal(this.value)
        },
        watch: {
            searchPatients(val) {
                if (!val || val.length < 3) return
                this.getPatients(val);
            },
            patientFound(newVal, oldVal) {
                if(newVal) {

                    if (this.multiple) {
                        let arr = this.value
                        if (!arr) {
                            arr = []
                        }
                        arr.push(newVal.id)
                        this.$emit('input', arr)

                        if (!this.patientChips) {
                            this.patientChips = []
                        }
                        this.patientChips.push({
                            id:newVal.id,
                            chip: `${newVal.first_name} ${newVal.last_name}`,
                        })

                        this.$nextTick(() => {
                            this.searchPatients = null

                        })
                    } else {
                        this.$emit('input', newVal.id)
                    }

                } else {
                    this.$emit('input', null)
                }
            }
        },
        methods: {
            ...mapActions('schedule',['scheduleSearchPatients']),
            unSelectChip(chip) {
                
                if (this.disabled) {
                    return 
                }
                let newArr = []
                let arr = this.value
                if (!arr) {
                    arr = []
                }
                arr.map(id => {
                    if (id !== chip.id) {
                        newArr.push(id)
                    }
                })
                this.$emit('input', newArr)

                let pindex = this.patientChips.findIndex(p => {
                    return p.id === chip.id
                })
                if (pindex >= 0){
                    this.patientChips.splice(pindex, 1)
                }

            },
            async loadLocal(value) {
                if (value) {
                    let arr 
                    if (Array.isArray(value)) {
                        arr = value
                    } else {
                        arr = [value]
                    }

                    let params = {
                        patient_ids: JSON.stringify(arr),
                    }
                    let initialPatients = await this.scheduleSearchPatients(params)
                    let patientChips = []
                    initialPatients.map(p => {
                        patientChips.push({
                            id:p.id,
                            chip: `${p.first_name} ${p.last_name}`,
                        })
                    })
                    this.patientChips = patientChips
                }
            },         
            getNamePatient(item) {
                if (this.nameFormat === 'last' ) {
                    return `${item.last_name}, ${item.first_name}`
                } else {
                    return `${item.first_name} ${item.last_name}`
                }
            },
            async getPatients(val) {
                this.isLoadingSearch = true;
                // console.log('TEST USER ID: ', this.userId && this.userId.id ? this.userId.id : null);
                try {
                    let params = {
                        search: val,
                        group_id: this.group_id,
                        limit: 30
                    }
                    this.items = await this.scheduleSearchPatients(params)

                    this.isLoadingSearch = false;

                } catch (e) {
                    this.isLoadingSearch = false;
                    // defaultErrorHandler(e);
                }
            }
        },
        computed: {
            patientSearchSelectedLocal: {
                get: function() {
                    // handle items array
                    if (!this.patientSearchSelected) {
                        this.items = [];
                    } else {
                        this.items = [this.patientSearchSelected];
                    }
                    return this.patientSearchSelected;
                },
                set: function(newValue) {
                    this.$emit('update:patientSearchSelected', newValue)
                }
            }
        }
    }
</script>
